import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Light unless someone chose dark. The system preference is deliberately not
 * consulted: a till that turns dark at sunset because macOS did is a surprise
 * nobody asked for, and the legacy app starts light too.
 */
export type ResolvedTheme = "light" | "dark";
export type ThemeChoice = ResolvedTheme;

interface ThemeState {
  choice: ThemeChoice;
  setChoice: (choice: ThemeChoice) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      choice: "light",
      setChoice: (choice) => set({ choice }),
    }),
    { name: "mrm.theme" },
  ),
);

/** Stamp the choice on `<html>`; the CSS keys every token off it. */
export function applyTheme(choice: ThemeChoice | null | undefined): void {
  document.documentElement.dataset["theme"] = choice ?? "light";
}

// Stamp the persisted choice on load and on every change, whatever route mounts
// first — the toggle only exists on the sign-in pages.
if (typeof document !== "undefined") {
  applyTheme(useThemeStore.getState().choice);
  useThemeStore.subscribe((state) => applyTheme(state.choice));
}
